import { ArrowRight, Calculator } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

export const FinalCta = () => (
  <section className="relative px-6 py-24 lg:py-44" data-testid="final-cta-section">
    <Reveal className="max-w-5xl mx-auto text-center">
      <h2 className="font-extrabold tracking-[-0.045em] leading-[1] text-5xl sm:text-6xl lg:text-8xl">Ora dipende da te.</h2>
      <p className="mt-8 text-2xl sm:text-3xl lg:text-4xl font-light tracking-[-0.025em] leading-[1.25] text-titanium max-w-3xl mx-auto">
        Vuoi creare il futuro con noi o lasciare che lo facciano gli altri?
      </p>
      <Link
        to="/aziende/piani"
        className="cta cta-primary cta-solid group mt-14 inline-flex items-center gap-3 rounded-full border px-10 py-5 text-base font-semibold text-white"
        data-testid="aziende-final-cta"
      >
        Scopri i piani e contattaci
        <ArrowRight className="h-4 w-4 text-cyan transition-transform duration-300 group-hover:translate-x-1" />
      </Link>
      <div className="mt-6">
        <Link
          to="/aziende/piani#calcolatore"
          className="nav-link inline-flex min-h-[44px] items-center gap-2 px-3 text-sm sm:text-base font-medium text-titanium hover:text-white"
          data-testid="aziende-final-calc-link"
        >
          <Calculator className="h-4 w-4 text-cyan" /> Calcola il tuo risparmio →
        </Link>
      </div>
    </Reveal>
  </section>
);
